/**
 * @generated SignedSource<<aa345f0cae763df13f040877260ec44b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MoreActionsAddRecipientMutation$variables = {
  id: string;
  userId: string;
};
export type MoreActionsAddRecipientMutation$data = {
  readonly addFeedbackRecipient: {
    readonly recipient: {
      readonly feedback: {
        readonly " $fragmentSpreads": FragmentRefs<"MoreActions_item">;
      };
      readonly id: string;
    };
  } | null;
};
export type MoreActionsAddRecipientMutation = {
  response: MoreActionsAddRecipientMutation$data;
  variables: MoreActionsAddRecipientMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MoreActionsAddRecipientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddFeedbackRecipient",
        "kind": "LinkedField",
        "name": "addFeedbackRecipient",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackRecipientNode",
            "kind": "LinkedField",
            "name": "recipient",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackNode",
                "kind": "LinkedField",
                "name": "feedback",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MoreActions_item"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoreActionsAddRecipientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddFeedbackRecipient",
        "kind": "LinkedField",
        "name": "addFeedbackRecipient",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedbackRecipientNode",
            "kind": "LinkedField",
            "name": "recipient",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FeedbackNode",
                "kind": "LinkedField",
                "name": "feedback",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDraft",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sharedWithMe",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isThreeSixtyParent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "context",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          }
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "OtherContext",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedbackRequestNode",
                    "kind": "LinkedField",
                    "name": "requests",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeedbackRecordNode",
                        "kind": "LinkedField",
                        "name": "feedbackRecord",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeedbackRecipientNode",
                    "kind": "LinkedField",
                    "name": "recipients",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e46d4fb7e46c9bbbdb02b3f9125d4e57",
    "id": null,
    "metadata": {},
    "name": "MoreActionsAddRecipientMutation",
    "operationKind": "mutation",
    "text": "mutation MoreActionsAddRecipientMutation(\n  $id: ID!\n  $userId: ID!\n) {\n  addFeedbackRecipient(id: $id, userId: $userId) {\n    recipient {\n      id\n      feedback {\n        ...MoreActions_item\n        id\n      }\n    }\n  }\n}\n\nfragment MoreActions_item on FeedbackNode {\n  id\n  type\n  isDraft\n  sharedWithMe\n  isThreeSixtyParent\n  creator {\n    id\n  }\n  context {\n    __typename\n    ... on User {\n      id\n      fullName\n      firstName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on OtherContext {\n      id\n    }\n  }\n  requests {\n    id\n    feedbackRecord {\n      id\n    }\n  }\n  recipients {\n    user {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c74aed7f5d507340e32519d9f4fd964";

export default node;
